import { RedditPost } from '../../Widget/Social/types';
import { RedditCard } from '../../Widget/Social/RedditCard';

export const RedditNews = ({ redditNews }: { redditNews: RedditPost[] }) => (
  <div className={'grid gap-4 grid-cols-2 p-4'}>
    {redditNews.map((item) => (
      <RedditCard post={item} key={item.id} />
    ))}
  </div>
);
